module.exports = __webpack_public_path__ + "img/fevend-presentation.060b3285.webp";